import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ProjectDocumentActions from './project-document.actions';
import { ProjectDocumentService } from '../../services/project-document.service';
import { Router } from '@angular/router';

@Injectable()
export class ProjectDocumentEffects {
  loadProjectDocument$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectDocumentActions.loadProjectDocument),
      exhaustMap((_) =>
        this.projectDocumentService.getProjectDocument().pipe(
          map((data) =>
            ProjectDocumentActions.loadProjectDocumentSuccess({
              projectDocument: data,
            })
          ),
          catchError((error) => {
            if (error.statusText === 'Unknown Error') {
              this.notification.error(
                'Unable to get response from server, please try again'
              );
            }

            return of(
              ProjectDocumentActions.loadProjectDocumentFailure({
                error,
              })
            );
          })
        )
      )
    )
  );

  addProjectDocument$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectDocumentActions.addProjectDocument),
      concatMap(({ newProjectDocument }) =>
        this.projectDocumentService
          .createProjectDocument(newProjectDocument)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ProjectDocumentActions.addProjectDocumentSuccess({
                newProjectDocument: data,
              });
            }),
            catchError((error) => {
              console.log('error ', error);

              return of(
                ProjectDocumentActions.addProjectDocumentFailure({
                  error: error.error.message,
                })
              );
            })
          )
      )
    )
  );

  // addSuccess$ = createEffect(
  // 	() =>
  // 		this.actions$.pipe(
  // 			ofType(ProjectDocumentActions.addProjectDocumentSuccess),
  // 			tap(() => {
  // 				return this.router.navigate([ '/project' ]);
  // 			})
  // 		),
  // 	{ dispatch: false }
  // );

  updateProjectDocument$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectDocumentActions.updateProjectDocument),
      concatMap(({ updateProjectDocument }) =>
        this.projectDocumentService
          .updateProjectDocument(updateProjectDocument)
          .pipe(
            map((data) => {
              // console.log('update effect data ', data);
              this.notification.success('Updated Successfully');
              return ProjectDocumentActions.updateProjectDocumentSuccess({
                updateProjectDocument: data,
              });
            }),
            catchError((error) => {
              return of(
                ProjectDocumentActions.updateProjectDocumentFailure({
                  error: error.message,
                })
              );
            })
          )
      )
    )
  );

  updateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProjectDocumentActions.updateProjectDocumentSuccess),
        tap(() => {
          console.log('navigate');
          return this.router.navigate(['/project']);
        })
      ),
    { dispatch: false }
  );

  removeProjectDocument$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectDocumentActions.removeProjectDocument),
      map((action) => action.ids),
      concatMap((ids) =>
        this.projectDocumentService.deleteProjectDocument(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ProjectDocumentActions.removeProjectDocumentSuccess({ ids });
          }),
          catchError((error) =>
            of(
              ProjectDocumentActions.updateProjectDocumentFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private projectDocumentService: ProjectDocumentService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
